const fs = require("fs");
const path = require("path");

const POLL_TIME = 500;

/**
 * Class for setting up a file watcher that will watch for specific files in a specified directory
 * and resolve when all has been created and read from disk.
 */
class FileWatcher {

  /**
   * Creates a FileWatcher object.
   * @example
   * let certificates = new FileWatcher("path/to/root", ["root.pem", "client_key.pem"]);
   * certificates.get().then( files )  {
   *     let root = files[0];
   *     let clientKey = files[1]
   * }
   * @param {string} directory - The directory containing the files that we're waiting for.
   * @param {Array<string>} filenames - Array of filenames described relative from the directory.
   */
  constructor(directory, filenames = []) {
    this.directory = directory || "";
    this.pathToFileMap = new Map();
    filenames.forEach(filename => {
      this.pathToFileMap.set(path.resolve(this.directory, filename), filename);
    });
    this.fileToContentMap = new Map();
  }

  checkWaitFile(start, filePath) {
    return new Promise((resolve, reject) => {
      let lastSize = 0;

      const check = () => {
        fs.stat(filePath, (statError, stats) => {
          if (statError && statError.code !== "ENOENT") {
            reject(statError);
          } else if (statError && statError.code === "ENOENT" || !stats.size || stats.size > lastSize) {
            lastSize = stats ? stats.size : lastSize;
            setTimeout(check, POLL_TIME);
          } else {
            fs.readFile(filePath, (readError, data) => {
              if (readError) {
                reject(readError);
              } else {
                this.fileToContentMap.set(this.pathToFileMap.get(filePath), data);
                resolve(filePath);
              }
            });
          }
        });
      };
      check();
    });
  }

  waitForFiles() {
    const promises = [];
    const start = Date.now();
    this.pathToFileMap.forEach((fileName, filePath) => {
      promises.push(this.checkWaitFile(start, filePath));
    });
    return Promise.all(promises).then(() => this.fileToContentMap);
  }

  /**
   * Gets the file content from the specified files.
   * @returns { Promise<Map<string,string>> } A promise that resolves to
   * a Map object containing the filename as keys and file content as values.
   */
  get() {
    if (this.fileToContentMap.size === this.pathToFileMap.size) {
      return Promise.resolve(this.fileToContentMap);
    }
    return this.waitForFiles();
  }
}

module.exports = {
  FileWatcher
};
